import { Language, useTranslations } from "@/lib";
import { Plus } from "lucide-react";
export default function EmptyItem({
  onClick,
  lang,
}: {
  onClick: () => void;
  lang: Language;
}) {
  const { t } = useTranslations(lang);
  return (
    <button
      className="tw:!grid tw:!items-center tw:!gap-4 tw:!py-4 tw:!font-bold tw:!cursor-pointer"
      onClick={onClick}
    >
      <div className="tw:flex tw:items-center tw:gap-5 tw:text-[15px]">
        <div className="tw:h-10 tw:w-10 tw:rounded-full tw:bg-primary tw:relative">
          <Plus className="tw:!h-7 tw:!w-7 tw:!text-foreground tw:!absolute tw:!top-1/2 tw:!left-1/2 tw:!-translate-x-1/2 tw:!-translate-y-1/2" />
        </div>
        {t("cushion_recommendations.add_for_trial")}
      </div>
    </button>
  );
}
